import React, { useState } from "react";
import { Container, Row, Col, Card, Button, Modal } from "react-bootstrap";
import { getHomeData } from "../data/home.js";
import "../pages/homePage/homePage.css";

const TestimonialsSection = () => {
  const [show, setShow] = useState(false);
  const [videoUrl, setVideoUrl] = useState("");

  const homeData = getHomeData();
  const headerContent = homeData.testimonial;
  const testimonials = homeData.testimonial.items;

  const getThumbnail = (item, index) => {
    if (item.image) return item.image;
    const videoId = item.videoUrl?.split('/embed/')[1]?.split('?')[0];
    return videoId ? `https://img.youtube.com/vi/${videoId}/maxresdefault.jpg` : '';
  };

  const handleShow = (url) => {
    // Add autoplay parameter to YouTube embed URL
    const autoplayUrl = url.includes('?') 
      ? `${url}&autoplay=1&rel=0` 
      : `${url}?autoplay=1&rel=0`;
    setVideoUrl(autoplayUrl);
    setShow(true);
  };

  const handleClose = () => {
    setShow(false);
    setVideoUrl("");
  };

  const handleVideoClick = (item) => {
    handleShow(item.videoUrl);
  };

  const handleJourneyClick = () => {
    const formSection = document.getElementById("trial-form-section");

    if (formSection) {
      formSection.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section className="testimonial-section mb-md-3">
      <Container fluid className="col-md-11 mx-auto">
        <Row className="align-items-start">

          <Col lg={4} className="mb-4 mb-lg-0" data-aos="fade-down">
            <h1 className="testimonial-title">
              <span className="d-block">
                {(headerContent?.title || "").split(" ")[0] || "Member's"}
              </span>
              <span className="d-block">
                {(headerContent?.title || "").split(" ").slice(1).join(" ") || "Testimonials"}
              </span>
            </h1>
            <p className="testimonial-subtext">
              {headerContent?.subtitle}
            </p>
            <Button
              className="journey-btn text-white"
              variant="none"
              data-aos="fade-down"
              data-aos-delay="200"
              onClick={handleJourneyClick}
            >
              {headerContent?.buttonText}
            </Button>
          </Col>

          <Col lg={8} className="overflow-hidden">
            <Row>
              {testimonials.map((item, index) => (
                <Col md={6} key={item.id} className="d-flex overflow-hidden" data-aos="fade-left" data-aos-delay={index * 80}>
                  <Card className="testimonial-card border-0 h-100 w-100">
                    
                  <div
                      className="video-wrapper"
                      onClick={() => handleVideoClick(item)}
                    >
                      <img
                        src={getThumbnail(item, index)}
                        alt={`${item.name} Testimonial`}
                        className="testimonial-video"
                      />
                      <div className="play-button">
                        <svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor" viewBox="0 0 16 16">
                          <path d="M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14zm0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16z"/>
                          <path d="M6.79 5.093A.5.5 0 0 0 6 5.5v5a.5.5 0 0 0 .79.407l3.5-2.5a.5.5 0 0 0 0-.814l-3.5-2.5z"/>
                        </svg>
                      </div>
                    </div>

                    <Card.Body className="d-flex flex-column">
                      <Card.Text className="testimonial-text flex-grow-1">
                        "{item.description}"
                      </Card.Text>
                      {/* <h6 className="testimonial-name">
                        {item.name}
                      </h6> */}
                    </Card.Body>

                  </Card>
                </Col>
              ))}
            </Row>
          </Col>
        </Row>
      </Container>

      <Modal
        show={show}
        onHide={handleClose}
        centered
        size="lg"
        className="testimonial-modal"
        backdrop="static"
      >
        <Modal.Body className="p-0 testimonial-modal-body">
          <button
            type="button"
            className="testimonial-modal-close"
            aria-label="Close video"
            onClick={handleClose}
          >
            <span className="mb-1" aria-hidden="true">&times;</span>
          </button>
          <div className="ratio ratio-16x9 testimonial-modal-ratio">
            <iframe
              src={videoUrl}
              title="Testimonial Video"
              allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
              allowFullScreen
            ></iframe>
          </div>
        </Modal.Body>
      </Modal>
    </section>
  );
};

export default TestimonialsSection;